import DataGrid, { Column } from "devextreme-react/data-grid";
import { ROPurchaseOrder } from "../types/RetailOrderDetails";

export default function MaterialOrderDatesGrid(props: { records: ROPurchaseOrder[] }) {

	return (
		<DataGrid
			className={'dx-card wide-card'}
			dataSource={props.records}
			allowColumnReordering={true}
			allowColumnResizing={true}
			showBorders={true}
			showColumnLines={true}
			columnAutoWidth={true}
			keyExpr={'purchaseOrderID'}
		>
			<Column
				dataField={'poNumber'}
				caption={'Purchase Order'}
				dataType="string"
			/>
			<Column
				dataField={'moNumber'}
				caption={'Material Order'}
				dataType="string"
			/>
			<Column
				dataField={'distributorName'}
				caption={'Distributor'}
				dataType="string"
			/>
			<Column
				dataField={'requestedShipDate'}
				caption={'Requested Ship Date'}
				dataType="date"
				format="shortDate"
			/>
			<Column
				dataField={'validatedShipDate'}
				caption={'Validated Ship Date'}
				dataType="date"
				format="shortDate"
			/>
			<Column
				dataField={'actualShipDate'}
				caption={'Actual Ship Date'}
				dataType="date"
				format="shortDate"
			/>
			<Column
				dataField={'requestedDeliveryDate'}
				caption={'Requested Delivery Date'}
				dataType="date"
				format="shortDate"
			/>
			<Column
				dataField={'validatedDeliveryDate'}
				caption={'Validated Delivery Date'}
				dataType="date"
				format="shortDate"
			/>
			<Column
				dataField={'deliveredDate'}
				caption={'Delivered Date'}
				dataType="date"
				format="shortDate"
			/>
		</DataGrid>
	);
}
